
import Vue, { PropType } from 'vue';

// Types and services
import { CandidateJobBuilder } from '~/utils/candidate';
import { SelectOption } from '~/components/builders/Base/Select.vue';
import { WorkPreference } from '~/services/CandidateService';

// Components
import AttributeCheckbox from '../components/AttributeCheckbox.vue';
import InfoBox from '../components/InfoBox.vue';
import Checkbox from '~/components/builders/Base/Checkbox.vue';

export default Vue.extend({
    name: 'PersonalPreferencesForm',
    components: { AttributeCheckbox, InfoBox, Checkbox },
    props: {
        builder: {
            type: Object as PropType<CandidateJobBuilder>,
            required: true,
        },
    },
    data() {
        const jobPreferences = this.builder.getPreferencesField('workPreferences') || [];

        return {
            job: !!jobPreferences.length,
            flex: this.builder.getPreferencesField('eligibleWorkLocation') || 'onsite',
            relo: this.builder.getPreferencesField('eligibleForRelocation') || false,
            lgb: this.builder.getPreferencesField('memberOfLGBTQCommunity') || false,
            eth: this.builder.getCandidateField('ethnicMinority') || 'no',
            pwd: this.builder.getCandidateField('disability') || 'no',

            jobPreferences,
            newsletter: this.builder.getCandidateField('newsletterConsent'),
        };
    },
    mounted() {
        this.$watch('newsletter', this.builder.watchCandidate('newsletterConsent'));

        this.$watch('eth', this.builder.watchCandidate('ethnicMinority'));
        this.$watch('pwd', this.builder.watchCandidate('disability'));

        this.$watch('flex', this.builder.watchPreference('eligibleWorkLocation'));
        this.$watch('relo', this.builder.watchPreference('eligibleForRelocation'));
        this.$watch('lgb', this.builder.watchPreference('memberOfLGBTQCommunity'));
        this.$watch('jobPreferences', this.builder.watchPreference('workPreferences'));
    },
    computed: {
        jobValue: {
            get(): boolean {
                return this.job;
            },
            set(value: boolean) {
                this.job = value;
                if (!value) this.jobPreferences = [];
            },
        },
        location: {
            get(): boolean {
                return this.flex !== 'onsite';
            },
            set(value: boolean) {
                this.flex = value ? 'remote_hybrid' : 'onsite';
            },
        },
        ethnic: {
            get(): boolean {
                return this.eth === 'yes';
            },
            set(value: boolean) {
                this.eth = value ? 'yes' : 'no';
            },
        },
        disability: {
            get(): boolean {
                return this.pwd === 'yes';
            },
            set(value: boolean) {
                this.pwd = value ? 'yes' : 'no';
            },
        },

        jobOptions(): SelectOption<WorkPreference>[] {
            const t = (id: string) =>
                this.$t(`profile.personalDetails.jobOptions.${id}`).toString();

            return [
                { value: 'internship', label: t('internship') },
                { value: 'graduate_program', label: t('graduate_program') },
                { value: 'part_time', label: t('part_time') },
                { value: 'full_time', label: t('full_time') },
                { value: 'volunteer', label: t('volunteer') },
            ];
        },
    },
});
